export default "__VITE_ASSET__BtHJy$Mt__"